import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import IProductGroupListItem from './IProductGroupListItem';
import { Table, Button } from 'react-bootstrap';
import ProductGroupListRow from './ProductGroupListRow';

interface IProductGroupListProps {
    items: IProductGroupListItem[];
    onEdit: (value: IProductGroupListItem) => void;
    onDelete: (value: IProductGroupListItem) => void;
    showLogs: (value: IProductGroupListItem) => void;
}

const ProductGroupList = (props: IProductGroupListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('product-groups/list/header/name')}</th>
                    <th>{Translate('product-groups/list/header/amount')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item: IProductGroupListItem) => (
                    <ProductGroupListRow
                        key={item.id}
                        productGroup={item}
                        onEdit={props.onEdit}
                        onDelete={props.onDelete}
                        showLogs={props.showLogs}
                    />
                ))}
            </tbody>
        </Table>
    );
};

export default ProductGroupList;
